import API_URLS from "constants/apis.url";

import { getLayoutURL } from "../utils/utils.js";

import { deleteRequest, getRequest, postRequest, putRequest } from "./api";

const DASHBOARD_URL = API_URLS.dashboardsURL;

export const getDashboard = layout => {
  const URL = layout ? getLayoutURL(DASHBOARD_URL, layout) : DASHBOARD_URL;
  return getRequest(URL);
};

const getURL = (id = null) => (id ? `${DASHBOARD_URL}/${id}/widgets` : DASHBOARD_URL);

export const addDashboardWidget = async widget => {
  const { LayoutID, ...payload } = widget;
  return await postRequest(`${getURL(LayoutID)}`, payload);
};

export const updateDashboardWidget = async widget => {
  const { LayoutID, Id, ...payload } = widget;
  return await putRequest(`${getURL(LayoutID)}/${Id}`, payload);
};

export const deleteDashboardWidget = async (layoutID, widgetID) => await deleteRequest(`${getURL(layoutID)}/${widgetID}`);

export const reorderDashboardWidgets = async widgets => {
  const { LayoutID, ...payload } = widgets;
  return await postRequest(`${getURL(LayoutID)}/reorder`, payload);
};

export const getWidgetData = params => getRequest("/telemetry", true, { params });

export const getTimeseriesData = params => getRequest(`${DASHBOARD_URL}/${API_URLS.timeSeriesURL}`, true, { params });

const DashboardAPIs = { addDashboardWidget, deleteDashboardWidget, getDashboard, updateDashboardWidget };

export default DashboardAPIs;
